import {useLoadingStore} from "../stores/loadingStore.js";
import { useValidationStore } from "../stores/validationStore.js";
import { getCurrentInstance } from 'vue'

export default {
    install(app) {
        app.config.globalProperties.store = async (url, formData) => {
            const loading = useLoadingStore();
            const validationStore = useValidationStore();
            //clear validation every time
            validationStore.clear()
            // start loading
            loading.setIsLoadingTrue()
            try {
                const { data: response } = await axios.post(url, formData);
                scrollToTop();
                const type = response.type &&  response.flash_type === '' ? response.type : response.flash_type;
                if (response.status) {
                    $toast(response.success ?? response.message, type);
                    // closeModal(modal, modalInput);
                    redirect(response.route ?? response.redirect_to, response.delay);
                    return response.status;
                } else {
                    $toast(response.error ?? response.message, 'error')
                }
            } catch (error) {
                console.error('Form submission error:', error);
                if (error.response?.status === 422) {
                    const backendErrors = error.response.data.errors;
                    validationStore.setErrors(backendErrors);
                    $toast(error.response.data?.message ?? 'Please fix validation errors.', 'error')
                    return error;
                } else {
                    $toast(error.message ?? 'An unexpected error occurred.', 'error');
                }
            } finally {
                loading.setIsLoadingFalse()
            }
        };

        app.config.globalProperties.update = async (url, id, formData) => {
            if (!id) {
                console.error('Update Id is required');
                return;
            }
            return app.config.globalProperties.store(`${url}/${id}`, formData);
        };
        const scrollToTop = () => {
            window.scrollTo({ behavior: 'smooth', top:0 });
        };
        const redirect = (url, delay = 0) => {
            if (url) {
                setTimeout(() =>{
                    window.location.href = url
                }, delay);
            } else {
                setTimeout(() =>{
                    window.location.reload();
                }, delay);
            }
        };

        const closeModal = (modal, modalInput) => {
            if (modal && modalInput?.value) {
                modal.classList.remove('show');
                modal.style.display = 'none';
                document.body.classList.remove('modal-open');
                document.querySelector('.modal-backdrop')?.remove();
            }
        }
    },
}
